import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 36.293 62.585",
  "content": "<symbol viewBox=\"0 0 36.293 62.585\" id=\"icon-arrow-right\">\r\n<path d=\"M1.464,1.465c-1.952,1.951-1.952,5.119,0,7.07l22.757,22.757L1.464,54.05c-1.952,1.951-1.952,5.119,0,7.07\r\n\tc1.953,1.953,5.119,1.953,7.071,0l26.293-26.293c0.977-0.976,1.465-2.257,1.465-3.536s-0.488-2.56-1.465-3.535L8.535,1.465\r\n\tC6.583-0.488,3.417-0.488,1.464,1.465\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/general/svg/arrow-right.svg
// module id = ./app/general/svg/arrow-right.svg
// module chunks = app